import parseDate from "../../../../controllers/parseDate";
import parseDropDownValue from "../../../../controllers/utils/parseDropDownValue";
import disputeResponseOptions from "../../../../data/dispute/disputeResponseOptions";
import CardForItem from "../../../customUiForCs/CardForItem";

export default function DisputeCard({ data, callback }) {
  const suspensionDays = data.suspensionDays ?? data.suspensionInDays;
  let title = `${data.reason}`;
  let image = null;
  let line1 = [
    {
      text: `${parseDate(data.date)} | Suspension : ${suspensionDays || "Non"} | Response : ${
        parseDropDownValue({
          query: data.response,
          theArray: disputeResponseOptions,
        }) || "Non"
      }`,
    },
  ];

  if (data.profile) {
    title = `${data.profile.lastName} ${data.profile.firstName}`;
    image = data.profile.profileImage;

    line1 = [
      {
        text: `${data.reason} | ${parseDate(data.date)} | Suspension : ${suspensionDays || "Non"} | Response : ${
          parseDropDownValue({
            query: data.response,
            theArray: disputeResponseOptions,
          }) || "Non"
        }`,
      },
    ];
  }

  let line2 = null;

  if (data.site) {
    if (!line2) line2 = [];
    line2.push({ text: `Site: ${data.site.placeName}` });
  }

  if (data.zone) {
    if (!line2) line2 = [];
    line2.push({ text: `Zone: ${data.zone.name}` });
  }

  return (
    <CardForItem
      callback={callback}
      itemType={"DISPUTE"}
      title={title}
      // image={image}
      line1={line1}
      line2={line2}
      editPath="edit-dispute"
      pagePath={null}
      itemID={data._id}
      absolutePath={`/employee/${data.userID}`}
    />
  );
}
